"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const createInstance_1 = __importStar(require("./http/createInstance"));
exports.parseAccountURL = (accountURL) => {
    if (!accountURL.startsWith('http')) {
        accountURL = `https://${accountURL}`;
    }
    const url = new URL(accountURL);
    const [accountName, ...rest] = url.host.split('.');
    const hostName = rest.join('.');
    const protocol = url.protocol.slice(0, -1);
    return {
        accountName,
        hostName,
        protocol,
    };
};
function createAPICall(fn) {
    return (...args) => {
        if (createInstance_1.isBridgeHTTPInstance(args[0])) {
            return fn(args[0]);
        }
        else {
            const [config, data] = args.reverse();
            const instance = createInstance_1.default(config);
            return fn(instance)(data);
        }
    };
}
exports.createAPICall = createAPICall;
exports.createAPIModule = (fns) => {
    const keys = Object.keys(fns);
    return (instance) => keys.reduce((map, key) => (Object.assign(Object.assign({}, map), { [key]: fns[key](instance) })), {});
};
//# sourceMappingURL=utils.js.map